import { getCityList as getCityData } from '@/apis/commonApi';
import fetch from '@/utils/fetch';

export const ALL_CITY_VALUE = -1;

export const CITY_TYPE = {
  ALL: 0,
  PART: 1,
};

export const ACTIVITY_STATUS_VALUE = {
  WAIT_START: 0,
  EFFECT: 1,
  OVER: 2,
  STOP_USE: 3,
};
export const ACTIVITY_STATUS_TEXT = {
  [ACTIVITY_STATUS_VALUE.WAIT_START]: '待开始',
  [ACTIVITY_STATUS_VALUE.EFFECT]: '生效中',
  [ACTIVITY_STATUS_VALUE.OVER]: '已结束',
  [ACTIVITY_STATUS_VALUE.STOP_USE]: '已停用',
};

const model = {
  state: {
    cityList: [],
    filterState: {
      pageNum: 1,
      pageSize: 10,
    },
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { ChiefActivityManage }, getState }) => ({
    async getChiefActivityList() {
      const resData = await fetch('/saasmerchant/web/customergroup/activity/list', {
        params: getState().ChiefActivityManage.filterState,
      });
      const { data, total } = resData || {};
      ChiefActivityManage.setState({
        ChiefActivityList: data,
        activityTotal: total,
      });
    },
    setFilter(params) {
      ChiefActivityManage.setState({
        filterState: { ...getState().ChiefActivityManage.filterState, ...params },
      });
    },
    async getCityList() {
      const data = await getCityData();
      const cityList = data?.map((province) => province.children || []).flat() || [];
      ChiefActivityManage.setState({
        cityList: [
          {
            label: '全部',
            value: ALL_CITY_VALUE,
          },
          ...cityList,
        ],
      });
    },
    async updateActivityStatus(params) {
      const resData = await fetch('/saasmerchant/web/customergroup/activity/stop', {
        params,
        type: 'POST',
        useJson: true,
      });
      return resData;
    },
    async getActivityDetail(activityId) {
      const activityDetailData = await fetch('/saasmerchant/web/customergroup/activity/detail', {
        params: { activityId },
      });
      return activityDetailData;
    },
    async addNewActivity(params = {}) {
      const activityDetailData = await fetch('/saasmerchant/web/customergroup/activity/save', {
        params,
        type: 'POST',
        useJson: true,
      });
      return activityDetailData;
    },
    async updateActivityData(params) {
      const resData = await fetch('/saasmerchant/web/customergroup/activity/update', {
        params,
        type: 'POST',
        useJson: true,
      });
      return resData;
    },
  }),
};

export default model;
